export default __webpack_public_path__ + "images/bc3a58a8b0f594b7397c2b2570914457-emoji-sleepy.svg";